import React from 'react';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';
import MainTable from './MainTable';
/**
 * * 하위 테이블 / 콜랍스 펼쳤을 때 보여지는 내부 테이블
 */

interface IPaginationProps {
  defaultPageSize?: number;
  showSizeChanger?: boolean;
}
interface IProps {
  columns?: object[];
  dataSource?: object[] | undefined;
  rowKey?: string | number | undefined | any;
  onChange?: () => void;
  pagination?: string[] | any | IPaginationProps;
  backgroundColor?: string;
  style?: React.CSSProperties;
  showHeader?: boolean;
  props?: any;
}
const SubordinateTable = ({
  columns,
  dataSource,
  rowKey,
  style,
  pagination,
  showHeader,
  ...props
}: IProps) => {
  const handlePageChange = (page, pageSize) => {
    // console.log(page);
  };
  return (
    <StyledTable
      columns={columns}
      dataSource={dataSource}
      rowKey={rowKey}
      style={style}
      showHeader={showHeader}
      pagination={handlePageChange}
      {...props}
    />
  );
};

export default SubordinateTable;

const StyledTable = styled(MainTable)<IProps>`
  margin: 0 auto;

  .ant-table {
    background: transparent;
    box-shadow: unset;
  }
  .ant-table-thead > tr > th {
    padding: 0.5rem 0.8rem;
    color: ${theme.colors.gray_2};
    background-color: ${theme.colors.gray_4};
    font-weight: 600;
  }

  .ant-table-cell {
    padding: 0;
  }
`;
